import { Node } from '@tiptap/vue-2';

/**
 * Basic block and nestable div node extension.
 */
export const DivExtension = Node.create({
  name: 'div',
  group: 'block',
  content: 'block+',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', HTMLAttributes, 0];
  },
});
